import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-participant-planning-calendar-card',
  templateUrl: './participant-planning-calendar-card.component.html',
  styleUrls: ['./participant-planning-calendar-card.component.scss']
})
export class ParticipantPlanningCalendarCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
